import React, { useState } from 'react';
import api from '../utils/api';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import './styles/PaymentReportMonthlyPage.css';
import moment from 'moment';

const PaymentReportMonthlyPage = () => {
    const [reportDate, setReportDate] = useState('');
    const [report, setReport] = useState(null);
    const [branchReports, setBranchReports] = useState([]);


    const handleSearch = async () => {
        try {
            const response = await api.post('/report/payment/monthly',
                {
                    data: [{
                        reportDate: reportDate
                    }]
                }
            );
            setReport(response.data.data);
    
            // Dapatkan laporan per cabang
            const branchResponse = await api.post('/report/payment/monthly/branch',
                {
                    data: [{
                        reportDate: reportDate
                    }]
                }
            );
            setBranchReports(branchResponse.data.data);
        } catch (error) {
            console.error('Error fetching monthly report:', error);
        }
    };
    

    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };

    const overallTotal = report ? report.savings.reduce((acc, saving) => parseFloat(acc) + parseFloat(saving.total_amount), 0) : 0;

    const exportPDF = () => {
        const reportContent = document.getElementById('reportContent');
        const reportTitle = `Laporan Pendapatan Bulanan Kidola - ${moment(reportDate).format('MMMM YYYY')}`;
        const pdf = new jsPDF();
    
        pdf.text(reportTitle, 10, 10); // Add the title at the top
    
        html2canvas(reportContent).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const imgWidth = 190; // PDF width in jsPDF
            const pageHeight = pdf.internal.pageSize.height;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let position = 20; // Adjust to leave space for the title
    
            pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
    
            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }
    
            pdf.save(`Kidola_Monthly_Report_${moment(reportDate).format('MMMM_YYYY')}.pdf`);
        }).catch((error) => console.error('Error generating PDF:', error));
    };
    

    return (
        <div className="report-page">
            <div className="page-title">Kidola Monthly Report</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <label>Income Month</label>
                                </td>
                                <td>
                                    <input 
                                        type="month"
                                        name="reportDate"
                                        value={reportDate} 
                                        onChange={e => setReportDate(e.target.value)}
                                    />
                                </td>  
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <button onClick={handleSearch}>Search</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                <div className="section">
                <div id="reportContent">
                    {branchReports.map((branchReport, index) => (
                        <div key={index} className="branch-report">
                            <h3>Branch - {branchReport.branchName}</h3>

                            <div className="student-report-table">
                                <h4>Student Report</h4>
                                <table>
                                    <tbody>
                                        <tr><td>Siswa Baru</td><td>{branchReport.studentReport.newStudents}</td></tr>
                                        <tr><td>Siswa Aktif</td><td>{branchReport.studentReport.activeStudents}</td></tr>
                                        <tr><td>Siswa Cuti / Off</td><td>{branchReport.studentReport.onLeaveStudents}</td></tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="report-table">
                                <h4>Finance Report</h4>
                                <table>
                                    <tbody>
                                    <tr>
                                            <td>SPP</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(branchReport.financeReport.SPP)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Modul</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(branchReport.financeReport.Modul)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Pendaftaran</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(branchReport.financeReport.Pendaftaran)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Mutation Fee</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(branchReport.financeReport["Mutation Fee"] || 0)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Diskon Pendaftaran Buku</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(branchReport.financeReport.Discount)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Inventory</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(branchReport.financeReport.Inventory)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Kidola Class</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(branchReport.financeReport.Class)}</span></td>
                                        </tr>
                                        <tr>
                                            <td><strong>Grand Total Pendapatan</strong></td>
                                            <td><span className="red-currency">Rp</span><span className="red-currency">{formatCurrency(branchReport.financeReport.GrandTotal)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Total Pengeluaran</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(branchReport.financeReport.TotalExpense)}</span></td>
                                        </tr>
                                        <tr>
                                            <td><strong>Pendapatan Bersih</strong></td>
                                            <td><span className="red-currency">Rp</span><span className="red-currency">{formatCurrency(branchReport.financeReport["Pendapatan Bersih"])}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ))}

                    {report && (
                        <>
                            <div className="total-report-table">
                                <h3>Kidola Total Income </h3>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>SPP</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(report.SPP)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Modul</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(report.MODUL)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Kidola Class</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(report.CLASS)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Inventory</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(report.INVENTORY)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>STUDENT LEAVE</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(report["STUDENT LEAVE"])}</span></td>
                                        </tr>
                                        <tr>
                                            <td>MUTATION FEE</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(report["MUTATION FEE"] || 0)}</span></td>
                                        </tr>
                                        <tr>
                                            <td><strong>Total Pendapatan</strong></td>
                                            <td><span className="red-currency">Rp</span><span className="red-currency">{formatCurrency(report.TotalIncome)}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                        </>
                    )}
                    {report && (
                        <>
                            <div className="total-report-table">
                                <h3>Kidola Total Expense</h3>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Salary</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(report.EXPENSE_SALARY)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Rent</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(report.EXPENSE_RENT)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Central</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(report.EXPENSE_CENTRAL)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Kidola Class</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(report.EXPENSE_CLASS)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Inventory</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(report.EXPENSE_INVENTORY)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Other</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(report.EXPENSE_OTHER)}</span></td>
                                        </tr>
                                        <tr>
                                            <td><strong>Total Pengeluaran</strong>  </td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(report.TotalExpense)}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                        </>
                    )}
                    {report && (
                        <>
                            <div className="total-report-table">
                                <h3>Kidola Student Savings</h3>
                                <table>
                                    <tbody>
                                    {report.savings.map((saving, index) => (
                                        <tr key={saving.branch_name}>    
                                            <td>{saving.branch_name}</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(saving.total_amount)}</span></td>
                                        </tr>
                                    ))}
                                        <tr>
                                            <td><strong>Savings All Branches</strong></td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(overallTotal)}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                        </>
                    )}
                    {report && (
                        <>
                            <div className="total-report-table">
                                <h3>Kidola Grand Total</h3>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td><strong>Total Income</strong></td>
                                            <td><span className="red-currency">Rp</span><span className="red-currency">{formatCurrency(report.TotalIncome)}</span></td>
                                        </tr>
                                        <tr>
                                            <td>Total Expense</td>
                                            <td><span className="currency">Rp</span><span>{formatCurrency(report.TotalExpense)}</span></td>
                                        </tr>
                                        <tr>
                                            <td><strong>Grand Total</strong></td>
                                            <td><span className="red-currency">Rp</span><span className="red-currency">{formatCurrency(report.FIX_INCOME)}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                        </>
                    )}
                </div>
                {report && (
                    <button onClick={exportPDF} className="export-button">Export to PDF</button>
                )}
                </div>
            </div>
            
        </div>
    );
};

export default PaymentReportMonthlyPage;
